<div class="account-select">
  <div *ngIf="view">
    <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
  </div>
</div>
